import { watch } from 'vue';
import useState from '../../_util/hooks/useState';
import { generateColor } from '../util';
function hasValue(value) {
    return value !== undefined;
}
const useColorState = (defaultStateValue, option) => {
    const { defaultValue, value: color } = option;
    const [colorValue, setColorValue] = useState(() => {
        let mergeState;
        if (hasValue(color.value)) {
            mergeState = color.value;
        }
        else if (hasValue(defaultValue)) {
            mergeState = defaultValue;
        }
        else {
            mergeState = defaultStateValue;
        }
        return generateColor(mergeState);
    });
    watch(option.value, value => {
        setColorValue(generateColor(value));
    });
    return [colorValue, setColorValue];
};
export default useColorState;
